var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-js-wrapper"},[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"poster":_vm.poster}})])}
var staticRenderFns = []

export { render, staticRenderFns }